module.exports = __webpack_public_path__ + "img/h3-image-2.ac3cfe7b.png";